import { ERoomType } from '../../../../../packages/JsonQuery';

type TCommonRoomType = Extract<
  ERoomType,
  | ERoomType.FlatOneRoom
  | ERoomType.FlatTwoRooms
  | ERoomType.FlatThreeRooms
  | ERoomType.FlatFourRooms
  | ERoomType.FlatFiveRooms
  | ERoomType.FlatManyRooms
>;

const COMMON_ROOM_TYPE_NAMES = {
  [ERoomType.FlatOneRoom]: '1',
  [ERoomType.FlatTwoRooms]: '2',
  [ERoomType.FlatThreeRooms]: '3',
  [ERoomType.FlatFourRooms]: '4',
  [ERoomType.FlatFiveRooms]: '5',
  [ERoomType.FlatManyRooms]: '6+',
};

export const getCommonRoomTypeNames = (roomTypes: ERoomType[]): string[] => {
  const roomTypesSorted = roomTypes.filter(type => type in COMMON_ROOM_TYPE_NAMES).sort() as TCommonRoomType[];

  if (roomTypesSorted.length < 3) {
    return roomTypesSorted.map(type => COMMON_ROOM_TYPE_NAMES[type]);
  }

  const sequences: [TCommonRoomType, TCommonRoomType][] = [];

  let seq: [TCommonRoomType, TCommonRoomType] = [roomTypesSorted[0], roomTypesSorted[0]];
  roomTypesSorted.forEach((value, index) => {
    if (index === 0) {
      return;
    } else if (value - 1 === seq[1]) {
      seq[1] = value;
    } else {
      sequences.push(seq);
      seq = [value, value];
    }
  });

  sequences.push(seq);

  return sequences.map(([start, end]) => {
    return start === end
      ? COMMON_ROOM_TYPE_NAMES[start]
      : `${COMMON_ROOM_TYPE_NAMES[start]}${end - start > 1 ? ' - ' : ', '}${COMMON_ROOM_TYPE_NAMES[end]}`;
  });
};
